module.exports = __webpack_public_path__ + "img/Madeira.0fa89a39.png";